// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"c5e7ae7f","492":"23db2cae","781":"4220f102","805":"5eb35815"}[chunkId] + ".chunk.js";
};